import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { exists } from '@nu-art/ts-common';
const defaultVideoUnsupportedMessage = 'Video not supported in this browser';
export class TS_Video extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.source = nextProps.source;
        state.configuration = nextProps.configuration;
        state.unsupportedVideoMessage = nextProps.unsupportedVideoMessage ?? defaultVideoUnsupportedMessage;
        state.width = nextProps.width;
        state.height = nextProps.height;
        return state;
    }
    //######################### Logic #########################
    getControlsList = (config) => {
        if (!config)
            return;
        const list = [];
        if (config.noDownload)
            list.push('nodownload');
        return list.join(' ');
    };
    getProps = () => {
        return {
            width: this.state.width,
            height: this.state.height,
            autoPlay: this.state.configuration.autoplay,
            muted: this.state.configuration.muted,
            //Controls props
            controls: exists(this.state.configuration.controls),
            // @ts-ignore
            controlsList: this.getControlsList(this.state.configuration.controls)
        };
    };
    //######################### Render #########################
    render() {
        return _jsxs("video", { ...this.getProps(), children: [_jsx("source", { src: this.state.source.url, type: `video/${this.state.source.format}` }), this.state.unsupportedVideoMessage] });
    }
}
//# sourceMappingURL=Video.js.map